export var GET_AVAILABILITY = '[Availability] Get Availability';
export var GET_AVAILABILITY_SUCCESS = '[Availability] Get Availability Success';
export var GET_AVAILABILITY_ERROR = '[Availability] Get Availability Error';
export var GET_AVAILABLE_FREELANCERS = '[Availability] Get Availabile Freelancers';
export var GET_AVAILABLE_FREELANCERS_SUCCESS = '[Availability] Get Availabile Freelancers Success';
export var GET_AVAILABLE_FREELANCERS_ERROR = '[Availability] Get Availabile Freelancers Error';
var GetAvailability = /** @class */ (function () {
    function GetAvailability(payload) {
        this.payload = payload;
        this.type = GET_AVAILABILITY;
    }
    return GetAvailability;
}());
export { GetAvailability };
var GetAvailabilitySuccess = /** @class */ (function () {
    function GetAvailabilitySuccess(payload) {
        this.payload = payload;
        this.type = GET_AVAILABILITY_SUCCESS;
    }
    return GetAvailabilitySuccess;
}());
export { GetAvailabilitySuccess };
var GetAvailabilityError = /** @class */ (function () {
    function GetAvailabilityError(payload) {
        this.payload = payload;
        this.type = GET_AVAILABILITY_ERROR;
    }
    return GetAvailabilityError;
}());
export { GetAvailabilityError };
var GetAvailableFreelancers = /** @class */ (function () {
    function GetAvailableFreelancers(payload) {
        this.payload = payload;
        this.type = GET_AVAILABLE_FREELANCERS;
    }
    return GetAvailableFreelancers;
}());
export { GetAvailableFreelancers };
var GetAvailableFreelancersSuccess = /** @class */ (function () {
    function GetAvailableFreelancersSuccess(payload) {
        this.payload = payload;
        this.type = GET_AVAILABLE_FREELANCERS_SUCCESS;
    }
    return GetAvailableFreelancersSuccess;
}());
export { GetAvailableFreelancersSuccess };
var GetAvailableFreelancersError = /** @class */ (function () {
    function GetAvailableFreelancersError(payload) {
        this.payload = payload;
        this.type = GET_AVAILABLE_FREELANCERS_ERROR;
    }
    return GetAvailableFreelancersError;
}());
export { GetAvailableFreelancersError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/store/actions/availability.action.ts.pre-build-optimizer.js